import React from 'react';
import cx from 'classnames';
import Modal from '../../Modal';
import styles from './DownloadModal.module.scss';

function DownloadModal(props) {
  const { open, onClose, children, ...rest } = props;

  return (
    <Modal className={cx(styles.downloadModal)} open={open} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
}

export default DownloadModal;
